import React from 'react'

const Video = (props) => {
  const { video, ratio = '16x9', _uid, className } = props
  let videox
  let video_code
  if (video.includes('watch?')) {
    videox = video.split('?v=')
    video_code = videox[1]
  }
  if (video.includes('/embed/')) {
    videox = video.split('/embed/')
    video_code = videox[1]
  }
  if (video.includes('.be/')) {
    videox = video.split('.be/')
    video_code = videox[1]
  }
  return (
    <div className={`ratio ratio-${ratio}`}>
      <iframe
        className="xembed-responsive-item"
        title={'iframe-' + _uid}
        width="1920"
        height="1080"
        src={'https://www.youtube-nocookie.com/embed/' + video_code}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  )
}

export default Video
